export enum QuestionType {
  ABIERTA = 1,
  OPCION_MULTIPLE = 2,
}
